/* eslint-disable react/prop-types */
import React from 'react';

export const POContext = React.createContext({});

export const POProvider = ({ children }) => {
  const [data] = React.useState([]);
  const [currentPage] = React.useState(1);
  const [pageSize] = React.useState(10);
  const [search] = React.useState({
    searchBy: '',
    keyword: '',
  });
  const [filter] = React.useState({});
  const [sorter] = React.useState({});

  const onChange = (pagination, nextSearch, filter, sort, extra) => {};

  return (
    <POContext.Provider
      value={{
        data,
        onChange,
        pagination: {
          currentPage,
          pageSize,
        },
        sorter,
        filter,
        search,
      }}>
      {children}
    </POContext.Provider>
  );
};
